export { RatesContainer as Rates } from './container';
